export const PER_PAGE = 20;
export const INSTITUTION_KEY = 'id_inst';
export const TYPES = ['gp', 'gp-x', 'gp-f', 'ped', 'ped-x', 'gyn', 'den', 'den-y', 'den-s'];
